// Traducción de nombres del catálogo para la versión en español.
// Regla: los nombres de marca ("OMNIA ...") y los que contienen "OS" se mantienen
// en inglés. El resto (studios y secciones) se traduce cuando el idioma es español.
const STUDIO_ES = {
  "ROLLOUT Studio": "ROLLOUT Studio",
  "RETAIL Studio": "RETAIL Studio",
  "SERVICE Studio": "SERVICE Studio",
  "WORKSHOP Studio": "WORKSHOP Studio",
  "AI Assistant Studio": "Asistente IA",
  "AI Development Studio": "Desarrollo de IA",
  "AI Platform Studio": "Plataforma de IA",
  "Accounting Studio": "Contabilidad",
  "Accounts Receivable Studio": "Cuentas por Cobrar",
  "Automation Studio": "Automatización",
  "Benefits Studio": "Prestaciones",
  "CEO Studio": "Dirección General (CEO)",
  "CFO Studio": "Dirección Financiera (CFO)",
  "COO Studio": "Dirección de Operaciones (COO)",
  "Collaboration Studio": "Colaboración",
  "Command Center Studio": "Centro de Mando",
  "Core HR Studio": "RH Central",
  "Corporate Governance Studio": "Gobierno Corporativo",
  "Culture & Engagement Studio": "Cultura y Compromiso",
  "Customer Experience Studio": "Experiencia del Cliente",
  "Digital Workplace Studio": "Espacio Digital",
  "Document Management Studio": "Gestión Documental",
  "Employee Experience Studio": "Experiencia del Empleado",
  "Employee Services Studio": "Servicios al Empleado",
  "Enterprise Performance Studio": "Desempeño Empresarial",
  "Events Marketing Studio": "Marketing de Eventos",
  "Executive Command Center Studio": "Centro de Mando Ejecutivo",
  "Executive Intelligence Studio": "Inteligencia Ejecutiva",
  "Executive Studio": "Ejecutivo",
  "Financial Intelligence Studio": "Inteligencia Financiera",
  "Financial Management Studio": "Gestión Financiera",
  "IT Operations Studio": "Operaciones de TI",
  "Integration & Data Studio": "Integración y Datos",
  "Integrations Studio": "Integraciones",
  "Learning Studio": "Aprendizaje",
  "Marketing Automation Studio": "Automatización de Marketing",
  "Marketplace Studio": "Marketplace",
  "Operations Studio": "Operaciones",
  "Payroll Studio": "Nómina",
  "People Analytics Studio": "Analítica de Personal",
  "Performance Studio": "Desempeño",
  "Platform Administration Studio": "Administración de Plataforma",
  "Project Management Studio": "Gestión de Proyectos",
  "Sales CRM Studio": "CRM de Ventas",
  "Strategy Studio": "Estrategia",
  "Talent Acquisition Studio": "Atracción de Talento",
  "Talent Management Studio": "Gestión del Talento",
  "Talent Studio": "Talento",
  "Wellness Studio": "Bienestar",
  "Workflow Studio": "Flujos de Trabajo",
  "Workforce Management Studio": "Gestión de Personal",
  "Workspace Studio": "Espacio de Trabajo",
};

// Studios de marca que se mantienen tal cual (GOÛT, TAGMA, VETTA, AURA, Human OS...).
const isBrand = (name) =>
  /OMNIA|GOÛT|GOUT|TAGMA|VETTA|AURA|\bOS\b/.test(name);

export function locStudio(name, lang) {
  if (lang !== "es" || !name) return name;
  if (STUDIO_ES[name]) return STUDIO_ES[name];
  if (isBrand(name)) return name;
  // Fallback: quita el sufijo " Studio" cuando no hay traducción explícita.
  return name.replace(/ Studio$/, "");
}
